<template>
    <div class="file-wrapper">
        <div class="text-center">
            <i v-bind:class="iconClass" @click.prevent="handleFileClick"/>
        </div>
        <v-col>
            <div class="first-line">
                <span class="text-truncate file-name text-center">
                  <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ file.name }}</span>
                      </template>
                    <span>{{ file.name }}</span>
                  </v-tooltip>
                </span>
            </div>
            <div v-if="file.size" class="file-size text-center">{{ file.size | FormatBytes($i18n)}}</div>
            <div v-if="!!file.error" class="error-text text-center">Upload error</div>
        </v-col>
        <v-progress-circular v-if="!file.success && file.progress < 100"
                             class="upload-status"
                             color="primary"
                             size="13"
                             v-model="file.progress"></v-progress-circular>
        <i v-if="file.success" class="upload-status fa fa-check-circle upload-success"></i>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <i v-on="on" v-if="!!file.error" class="upload-status fa fa-times-circle upload-fail"></i>
            </template>
            <span>{{ file.error }}</span>
        </v-tooltip>
        <i v-if="!readonly" class="fas fa-trash-alt file-delete-button" @click="handleDeleteButtonClick"/>
    </div>
</template>

<script>
    import _ from 'lodash'
    import FormatBytes from '../Filters/FormatBytes'
    import {getBaseApiURL} from '../../helpers/baseurl'
    import api from '../../api'
    import FileSaver from 'file-saver'
    import {detectIconClassByMimeType} from '@/components/Files/utils'
    import {mapActions} from 'vuex'

    export default {
        name: 'Item',
        props: {
            file: Object,
            readonly: Boolean,
            directDownload: Boolean
        },
        filters: {
            FormatBytes
        },
        computed: {
            fileLink () {
                return `${getBaseApiURL()}files/get?id=${this.file.fileId}`
            },
            iconClass() {
                const mimeType = _.get(this.file, 'mimeType', null)
                let iconClass = detectIconClassByMimeType(mimeType)

                return {
                    fas: true,
                    'file-link': true,
                    'file-icon': true,
                    [iconClass]: true
                }
            }
        },
        methods: {
            ...mapActions({
              fileViewerOpen: 'fileViewerOpen'
            }),
            handleDeleteButtonClick () {
                this.$emit('delete', this.file.fileId)
            },
            async handleFileClick() {
              this.$emit('click', {
                source: this.fileLink,
                title: this.file.name,
                mimeType: this.file.mimeType
              })

              if (this.directDownload) {
                try {
                  let fileData = await api.getFile(this.file.fileId)
                  let blob = new Blob([fileData], { type: this.file.mimeType })

                  FileSaver.saveAs(blob, this.file.name)
                } catch (e) {
                  console.log(`Unable to download report, details: ${e.message}`)
                }
              }
            }
        }
    }
</script>

<style scoped>
    .file-wrapper {
        margin: 10px;
        position: relative;
        max-width: 120px;
        width: 120px;
        height: 90px;
    }

    .file-icon {
        color: #000000;
        font-size: 40px;
    }

    .file-delete-button {
        position: absolute;
        left: 79px;
        top: -10px;
        color: #cacaca;
    }

    .file-delete-button:hover {
        color: red !important;
        cursor: pointer;
    }

    .upload-status {
        position: absolute;
        left: 79px;
        top: 9px;
    }

    .file-wrapper .error-text {
        color: #ff5252;
        font-size: 11px;
    }

    .file-wrapper .first-line {
        font-weight: 500;
    }

    .file-wrapper .first-line .file-name {
        display: block;
    }

    .file-wrapper .upload-success {
        color: #4CAF50;
    }

    .file-wrapper .upload-fail {
        color: #ff5252;
    }

    .file-wrapper .file-size {
        font-size: 11px;
        opacity: .7;
    }

    .file-link {
        cursor: pointer;
    }
</style>